import { gtccGet, type GtccResult } from "./gtcc-result.js";

export const SEC_SUMMARY_PATH = "/v1/admin/gtcc/sec/summary";
export const SEC_SUMMARY_KEY = ["gtcc", "sec", "summary"] as const;

export interface SecMeasurement {
  readonly value: number | null;
  readonly status: "measured" | "not_measured";
  readonly reason: string | null;
}

export interface SecSummaryDto {
  readonly measuredAt: string;
  readonly activeSessions: SecMeasurement;
  readonly failedLogins24h: SecMeasurement;
  readonly rlsForce: {
    readonly forced: number | null;
    readonly total: number | null;
    readonly status: "measured" | "not_measured";
    readonly reason: string | null;
  };
  readonly pkce: { readonly enforced: true; readonly method: "S256"; readonly source: string };
  /**
   * The repository half of the sheet: the committed scan result, not a live read.
   *
   * `measuredAt` is the scan's own timestamp and deliberately not the summary's
   * — the freshness badge on the head vouches for the database rows only, and a
   * repository fact is exactly as old as the scan that produced it.
   */
  readonly repositoryFacts: {
    readonly measuredAt: string | null;
    readonly sources: readonly string[];
    readonly supportPasswordRotation: SecMeasurement;
    /** `value` = versioned wrapper scripts; `sudoersReferenced` = wrappers the sudoers files name. */
    readonly sudoersWrapper: SecMeasurement;
    readonly sudoersReferenced: number | null;
    readonly sudoersCommands: readonly string[];
    /** `value` = findings, so a measured `0` is the good case and never a blank. */
    readonly plaintextSecretsInScripts: SecMeasurement;
    readonly scannedShellFiles: number | null;
  };
}

export function fetchSecSummary(signal?: AbortSignal): Promise<GtccResult<SecSummaryDto>> {
  return gtccGet<SecSummaryDto>(SEC_SUMMARY_PATH, signal);
}
